import marketingContentType from './marketingContentType.json'

export default (itemType, currentMall, isMerchant) => {
  let baseUrl = '/promos-and-events'

  if (isMerchant && currentMall) return `/explore/${currentMall}/store`

  switch (itemType) {
    case marketingContentType.WHATSON:
      return `${baseUrl}/whats-on`
    case marketingContentType.BESTDEALS:
      return `${baseUrl}/best-deals`
    case marketingContentType.ADVERTISEMENT:
      return `${baseUrl}/ads`
    case marketingContentType.ANNOUNCEMENT:
      return `${baseUrl}/announcements`
    case marketingContentType.OTHERS:
      return `${baseUrl}/others`
    default:
      return baseUrl
  }
}
